import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { Field, FieldAttributes } from 'formik';
import { TextField } from 'formik-mui';
import React, { useCallback, useMemo, useState } from 'react';

type Props = FieldAttributes<any>;

export const FormikSecretField: React.FC<Props> = ({
  InputProps,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  const handleToggle = useCallback(() => setVisible((prev) => !prev), []);

  const inputProps = useMemo(
    () => ({
      ...InputProps,
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle secret visibility"
            onClick={handleToggle}
            edge="end"
            size="small"
          >
            {visible ? (
              <VisibilityOffIcon fontSize="small" />
            ) : (
              <VisibilityIcon fontSize="small" />
            )}
          </IconButton>
        </InputAdornment>
      ),
    }),
    [InputProps, handleToggle, visible],
  );

  return (
    <Field
      component={TextField}
      type={visible ? 'text' : 'password'}
      size="small"
      autoComplete="off"
      {...props}
      InputProps={inputProps}
    />
  );
};
